<template>
  <li
    class="list-none my-1 mx-0 border-b border-slate-200"
    :tabindex="null"
    :aria-disabled="true"
  />
</template>
<script>
export default {};
</script>
